/* Version: 3.5.155 */
'use client';
import styled from 'styled-components';
import { BREAKPOINTS } from '../../spacing/index.js';
import { rem } from '../../utils/functions.js';
import { FocusOutline } from '../../mixins/index.js';
import { ACCORDION_VARIANT } from './constants.js';
import { typography } from '../../typography/typography.js';

// Styled components for Accordion
var AccordionWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__AccordionWrapper",
  componentId: "sc-1c2u5ii-0"
})(["font-family:", ";line-height:", ";width:100%;box-sizing:border-box;background-color:", ";color:", ";", ""], typography.fontFamily, typography.lineHeight, function (_ref) {
  var variant = _ref.variant,
    theme = _ref.theme;
  return variant === ACCORDION_VARIANT.SECONDARY ? 'transparent' : theme.colorPalette.neutralColors.light.shade_white;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_1;
}, function (_ref3) {
  var expandablePanelStyle = _ref3.expandablePanelStyle;
  return expandablePanelStyle;
});
process.env.NODE_ENV !== "production" ? AccordionWrapper.displayName = 'AccordionWrapper' : undefined;

// NOTE: This empty styled component gets acted on by other components
var InnerWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__InnerWrapper",
  componentId: "sc-1c2u5ii-1"
})([""]);
process.env.NODE_ENV !== "production" ? InnerWrapper.displayName = 'InnerWrapper' : undefined;
var SecondaryAccordionWrapper = /*#__PURE__*/styled(AccordionWrapper).withConfig({
  displayName: "styledComponents__SecondaryAccordionWrapper",
  componentId: "sc-1c2u5ii-2"
})(["padding:0 20px;@media (max-width:", "px){padding:0;}", "{padding:20px 0;border-bottom:1px solid ", ";border-top:1px solid ", ";}", ":hover,", ":focus-within{border-color:", ";}"], BREAKPOINTS.MAX_1024, InnerWrapper, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_4;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_4;
}, InnerWrapper, InnerWrapper, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_3;
});
process.env.NODE_ENV !== "production" ? SecondaryAccordionWrapper.displayName = 'SecondaryAccordionWrapper' : undefined;
var PrimaryAccordionWrapper = /*#__PURE__*/styled(AccordionWrapper).withConfig({
  displayName: "styledComponents__PrimaryAccordionWrapper",
  componentId: "sc-1c2u5ii-3"
})(["padding:20px;border:", ";", "{padding:0;", "{position:relative;margin-bottom:-1px;}", ":hover,", ":focus-within{z-index:1;}:nth-child(1 of ", "){margin-top:20px;}:last-child ", "{border-bottom:none;}}:hover,:focus-within{border-color:", ";}"], function (_ref7) {
  var variant = _ref7.variant,
    theme = _ref7.theme;
  if (variant === ACCORDION_VARIANT.LEGAL) {
    return 'none';
  }
  return "1px solid ".concat(theme.colorPalette.neutralColors.dark.shade_light_4);
}, SecondaryAccordionWrapper, InnerWrapper, InnerWrapper, InnerWrapper, SecondaryAccordionWrapper, InnerWrapper, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_3;
});
process.env.NODE_ENV !== "production" ? PrimaryAccordionWrapper.displayName = 'PrimaryAccordionWrapper' : undefined;

// Styled components for Header
var HeaderButton = /*#__PURE__*/styled.button.withConfig({
  displayName: "styledComponents__HeaderButton",
  componentId: "sc-1c2u5ii-4"
})(["width:100%;display:flex;align-items:start;vertical-align:middle;cursor:pointer;background:transparent;border:none;padding:0;line-height:", ";color:", ";:hover,:focus{text-shadow:", ";}:focus-visible{", ";}", ""], typography.lineHeight, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_1;
}, function (_ref10) {
  var theme = _ref10.theme;
  return "\n      0 0.2px ".concat(theme.colorPalette.neutralColors.dark.shade_light_1, ",\n      0 -0.2px ").concat(theme.colorPalette.neutralColors.dark.shade_light_1, ",\n      0.2px 0 ").concat(theme.colorPalette.neutralColors.dark.shade_light_1, ",\n      -0.2px 0 ").concat(theme.colorPalette.neutralColors.dark.shade_light_1);
}, FocusOutline, function (_ref11) {
  var headerWrapperStyle = _ref11.headerWrapperStyle;
  return headerWrapperStyle;
});
process.env.NODE_ENV !== "production" ? HeaderButton.displayName = 'HeaderButton' : undefined;
var HeaderTitle = /*#__PURE__*/styled.span.withConfig({
  displayName: "styledComponents__HeaderTitle",
  componentId: "sc-1c2u5ii-5"
})(["font-size:", ";font-family:", ";font-weight:", ";", ""], function (_ref12) {
  var variant = _ref12.variant;
  if (variant === ACCORDION_VARIANT.LEGAL) {
    return rem(14);
  }
  if (variant === ACCORDION_VARIANT.SECONDARY) {
    return rem(16);
  }
  return rem(18);
}, typography.fontFamily, function (_ref13) {
  var variant = _ref13.variant;
  return variant === ACCORDION_VARIANT.LEGAL ? typography.fontWeightLight : typography.fontWeightDemibold;
}, function (_ref14) {
  var titleStyle = _ref14.titleStyle;
  return titleStyle;
});
process.env.NODE_ENV !== "production" ? HeaderTitle.displayName = 'HeaderTitle' : undefined;

// Styled components for Body
var BodyWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__BodyWrapper",
  componentId: "sc-1c2u5ii-6"
})(["padding-top:20px;margin-left:32px;line-height:", ";transition:flex 0.3s ease-out;height:auto;display:", ";font-weight:300;@media (max-width:", "px){margin-left:0;}", ""], rem(24), function (_ref15) {
  var isExpanded = _ref15.isExpanded;
  return isExpanded ? 'block' : 'none';
}, BREAKPOINTS.MAX_1024, function (_ref16) {
  var bodyStyle = _ref16.bodyStyle;
  return bodyStyle;
});
process.env.NODE_ENV !== "production" ? BodyWrapper.displayName = 'BodyWrapper' : undefined;
var IconWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "styledComponents__IconWrapper",
  componentId: "sc-1c2u5ii-7"
})(["line-height:1;flex-shrink:0;height:", ";display:inline-flex;flex-flow:column nowrap;justify-content:center;width:32px;"], typography.lineHeight);
process.env.NODE_ENV !== "production" ? IconWrapper.displayName = 'IconWrapper' : undefined;

export { BodyWrapper, HeaderButton, HeaderTitle, IconWrapper, InnerWrapper, PrimaryAccordionWrapper, SecondaryAccordionWrapper };
